import axios from 'axios';
import { useState } from 'react';
import { useMask } from '@react-input/mask';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
// icon
import { MdClose } from 'react-icons/md';
// style
import style from './contactModal.module.css';

const ContactModal = ({ modalIsOpen, handelModal }) => {
  const [buttonLoanding, setButtonLoanding] = useState(false);
  const [values, setValues] = useState({
    phone: '',
    name: '',
  });
  const [errors, setErrors] = useState({
    name: '',
    phone: '',
  });

  const notify = () =>
    toast.success('Заявка успешно отправлена', {
      autoClose: 2000,
      position: 'top-left',
    });

  const notifyError = () =>
    toast.error('Сообщение не отправлено. Повторите попытку', {
      autoClose: 2000,
      position: 'top-left',
    });
  const notifyErrorPhone = () =>
    toast.error('Пожалуйста, введите полный номер телефона', {
      autoClose: 2000,
      position: 'top-left',
    });

  // get data
  const getInputData = (event, name) => {
    setValues({ ...values, [name]: event.target.value });
  };

  // post data

  const onSubmit = async (event) => {
    event.preventDefault();

    if (!/^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(values.phone)) {
      notifyErrorPhone();
      return;
    }

    const TOKEN = '7633057171:AAHtb-PpITvZyjzI8D6gZCH8pQ56ghiPJwU';
    const CHAT_ID = '-1002513052092';
    const URL_API = `https://api.telegram.org/bot${TOKEN}/sendMessage`;

    let message = `<b>Имя:</b> ${values.name}\n`;
    message += `<b>Телефон:</b> ${values.phone}\n`;

    setButtonLoanding(true);

    try {
      await axios.post(URL_API, {
        chat_id: CHAT_ID,
        parse_mode: 'html',
        text: message,
      });
      notify();
      setValues({ name: '', phone: '' });
      phoneRef.current?.setSelectionRange(0, 0);
      setButtonLoanding(false);
    } catch (error) {
      setButtonLoanding(false);
      notifyError();
    }
  };

  const phoneRef = useMask({
    mask: '+7 (___) ___-__-__',
    replacement: { _: /\d/ },
  });

  return (
    <div
      className={modalIsOpen ? `${style.modal} ${style.active}` : style.modal}
      onClick={(e) => {
        if (e.target.classList.contains(style.modal)) {
          handelModal();
        }
      }}
    >
      <div className="container">
        <div className={style.box}>
          {/* header  */}
          <div className={style.header}>
            <h3>Заказать обратный звонок</h3>
            <span className={style.close} onClick={() => handelModal()}>
              <MdClose className={style.icon} />
            </span>
          </div>
          {/* content */}
          <div className={style.content}>
            <div className={style.form_content}>
              <form onSubmit={onSubmit}>
                <div className={style.input_box}>
                  <input
                    autoFocus
                    type="text"
                    name="имя"
                    placeholder="Ваше имя"
                    onChange={(e) => getInputData(e, 'name')}
                    required
                    value={values.name}
                    minLength="3"
                    className={errors.name ? style.errorInput : ''}
                  />
                  {errors.name && (
                    <span className={style.errorText}>{errors.name}</span>
                  )}

                  <input
                    type="tel"
                    name="Телефон"
                    value={values.phone}
                    ref={phoneRef}
                    onChange={(e) => getInputData(e, 'phone')}
                    placeholder="+7(___)___-__-__"
                    required
                    className={errors.phone ? style.errorInput : ''}
                  />
                  {errors.phone && (
                    <span className={style.errorText}>{errors.phone}</span>
                  )}

                  <button type="submit">
                    {!buttonLoanding ? (
                      'Отправить'
                    ) : (
                      <div className="send-lounding"></div>
                    )}
                  </button>
                </div>

                <div className={style.lega}>
                  <span>
                    Нажимая «Отправить», я даю согласие на обработку{` `}
                    <Link to="/privacy" onClick={() => handelModal()}>
                      персональных данных
                    </Link>
                    .
                  </span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ContactModal;
